<template>
  <div id="app">
    <Header />
    <Main />
    <!-- <Footer /> -->
  </div>
</template>

<script>
import $ from 'jquery'
import Header from '@/components/Header'
import Main from '@/components/Main'
// import Footer from '@/components/Footer'

export default {
  name: 'App',
  components: {
    Header,
    Main
  }
}
</script>

<style lang="scss">
@import './assets/main';
</style>



// WEBPACK FOOTER //
// src/App.vue